module.exports = __webpack_public_path__ + "img/CE8F3D_F0D2B0_F3C77D_E6B278-256px.a5531b6e.png";